import { Component, OnInit } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  displayed='accueil';
  private timeOut;

  constructor(private router: Router) { }

  ngOnInit() {
    this.startTimeOut();
    this.detectClick();
  }

  display(type) {
    console.log("displayVideos : ", type);
    clearTimeout(this.timeOut); // nécessaire car angular ne détruit pas le timeOut lorsque l'on navigue par le router

    switch(type) {
      case 'vidéos':
      case 'youtube':
      case 'tutos':
      case 'go animate':
        this.router.navigate(['videos/'+type]);
      break;
      case 'matinees-debats':
        console.log("display :", type);
        this.displayed=type;
        break;
      case 'cse':
        console.log("display :", type);
        this.displayed=type;
        break;
      case 'secafi-com':
            this.displayed=type;
            break;
      case 'entreprise-demain':
        this.displayed=type;
        break;
    }
  }

  goHome() {
    this.displayed="accueil";
  }

  download(type) {
    clearTimeout(this.timeOut); // nécessaire car angular ne détruit pas le timeOut lorsque l'on navigue par le router
    this.router.navigate(['contact/'+type]);
  }

  detectClick() { window.addEventListener('blur',()=> { // détecte juste le premier click sur la fenêtre
    if(document.activeElement.id == 'iframe') {
      console.log("click Iframe");
      this.startTimeOut();
      }
    })
  }


  startTimeOut(){
    console.log('startTimeOut');
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(()=>{
      this.goHome();
    }, 180000);
  }

}
